function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "play-summary-buttons-copy",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "path",
  transform: "translate(-58.000000, 0.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "path-dark",
  transform: "translate(58.000000, 0.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group",
  transform: "translate(16.000000, 6.000000) rotate(89.000000) translate(-16.000000, -6.000000) translate(13.000000, -9.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M2.79069767,27.9069767 C0.930232558,22.7906977 0,18.6046512 0,15.3488372 C0,12.0930233 0.930232558,7.90697674 2.79069767,2.79069767",
  id: "Path",
  stroke: "#4A4A4A",
  strokeWidth: 1.81395349
}), /*#__PURE__*/React.createElement("circle", {
  id: "Oval",
  fill: "#4A4A4A",
  cx: 2.79069767,
  cy: 2.79069767,
  r: 2.79069767
}), /*#__PURE__*/React.createElement("circle", {
  id: "Oval-Copy",
  fill: "#4A4A4A",
  cx: 2.72093023,
  cy: 27.8372093,
  r: 2.1627907
})))));

function SvgPath(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "10px",
    viewBox: "0 0 32 10",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPath);
export default __webpack_public_path__ + "static/media/path.02e2bae5.svg";
export { ForwardRef as ReactComponent };